/**
 * Picks v2 or v1 of the Categories page based on the redesign flag.
 * Same pattern as SessionsPageSwitch / DashboardPageSwitch / LoginSwitch.
 */
import React from 'react';
import { useRedesignFlag } from '../../../utils/redesignFlag';
import CategoryPage   from './CategoryPage';
import CategoryPageV2 from './CategoryPageV2';

export default function CategoryPageSwitch(props) {
  const [v2] = useRedesignFlag();
  const Component = v2 ? CategoryPageV2 : CategoryPage;
  return <Component {...props} />;
}
